import { PropsWithChildren, useEffect, useState } from 'react';
import Client from 'fhirclient/lib/Client';
import styled from '@emotion/styled'
import { fhirclient } from 'fhirclient/lib/types';
import { Panel, PatientBanner, Banner } from './components';
import { Actions, useAdministrationStateContext } from './components/state';
import { Medications } from './fhir';
import logo from './images/FDB_logo.svg';
import { initializeIcons } from 'office-ui-fabric-react';

initializeIcons();

export type AppLaunchProps = {
  client: Client;
}

const Page = styled.div`
`

const Header = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  margin-left: 1rem;
  margin-right: 1rem;
`

const Logo = styled.div`
  margin: 0.5rem;
`

const Title = styled.div`
  font-weight: bold;
  color: #133B63;
  font-size: 25px;
`

export type MedicationListItem = {
  dosageInstruction: "";
  medication: "";
  status: "";
  }

export function App({ client }: PropsWithChildren<AppLaunchProps>){
  const { dispatch } = useAdministrationStateContext();
  const [patient, setPatient] = useState<fhirclient.FHIR.Patient>({} as fhirclient.FHIR.Patient);

  useEffect(() => {
    Promise.all([
      client.patient.read()
    ])
    .then(
      ([patient]) => {
        setPatient(patient);
      },
      error => {
          console.error(error);
      }
    ).catch((error) => {
        dispatch(Actions.AddError({message: 'Error occured while fetching patient details.', stacktrace: error.message}))
      }
    )
  }, [client, dispatch]);

  return (
    <Page>
      <Banner>
        <Header>
          <Logo>
            <img alt='FDB Logo' src={logo} />
          </Logo>
          <Title>
            Patient Medications Sandbox
          </Title>
        </Header>
        <Header>
          <PatientBanner patient={patient}/>
        </Header>
      </Banner>
      <Panel>
        <Medications client={client} patient={patient} />
      </Panel>
    </Page>
  );
}

export default App;
